import {
  GENERATE_WORK_FOLDER_REQUEST,
  GENERATE_WORK_FOLDER_SUCCESS,
  GENERATE_WORK_FOLDER_FAILURE,
  BOX_TRANSCRIPT_PRODUCTS_REQUEST,
  BOX_TRANSCRIPT_PRODUCTS_SUCCESS,
  BOX_TRANSCRIPT_PRODUCTS_FAILURE
} from '../actions/boxTranscriptProductActions.js'

const initialState = {
  isFetching: false,
  items: [],
  idsGenerating: []
}

export default function boxTranscriptProducts(state = initialState, action) {
  switch (action.type) {
    case BOX_TRANSCRIPT_PRODUCTS_REQUEST:
      return Object.assign({}, state, { isFetching: true })
    case BOX_TRANSCRIPT_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.response.result
      })
    case BOX_TRANSCRIPT_PRODUCTS_FAILURE:
    case GENERATE_WORK_FOLDER_FAILURE:
      return Object.assign({}, state, { isFetching: false })
    case GENERATE_WORK_FOLDER_REQUEST:
      return Object.assign({}, state, {
        idsGenerating: [...state.idsGenerating, action.idsGenerating],
        isFetching: true
      })
    case GENERATE_WORK_FOLDER_SUCCESS:
      const idx = state.idsGenerating.indexOf(action.idsGenerating)
      return Object.assign({}, state, {
        isFetching: false,
        idsGenerating: [
          ...state.idsGenerating.slice(0, idx),
          ...state.idsGenerating.slice(idx + 1)
        ]
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../src/reducers/boxTranscriptProducts.js